export const MIN_RESPONSES_FOR_AI_ANALYSIS = 5
export const DIALOG_AVATAR_IMAGE_URL =
  'https://api.dicebear.com/9.x/big-smile/png?seed='
